import { ReactNode } from "react";
import "./Overlay.css";

export type OverlayProps = {
  suffix: string;
  children: ReactNode;
  dismissButtonText: string;
  onDismissed: () => void;
}

export const Overlay: React.FC<OverlayProps> = ({suffix, children, dismissButtonText, onDismissed}: OverlayProps) => {
  return (
  <>
    <div id="Backdrop"></div>
    <aside className={`Overlay ${suffix}`}>
      {children}
      <button className="tube" onClick={onDismissed}>{dismissButtonText}</button>
    </aside> 
  </>)
}